import { render, staticRenderFns } from "./articlelist.vue?vue&type=template&id=297eb956&"
import script from "./articlelist.vue?vue&type=script&lang=js&"
export * from "./articlelist.vue?vue&type=script&lang=js&"
import style0 from "./articlelist.vue?vue&type=style&index=0&id=297eb956&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports